"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _ThemeService = require("../common/ThemeService");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var TurnOrRiverCard = function TurnOrRiverCard(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: props.name,
    style: {
      width: props.innerWidth
    }
  }, props.cardUrl && props.cardUrl.length === 1 ? props.cardUrl.map(function (card, index) {
    return /*#__PURE__*/_react["default"].createElement("img", {
      key: index,
      className: "MyTopHandsCardsCss",
      src: card,
      style: {
        marginRight: "0px"
      }
    });
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "MyTopHandsCardsCss",
    style: {
      backgroundColor: "#F5F5F5",
      marginRight: "0px",
      boxShadow: "1px 1px 4px 0px lightgrey"
    }
  }));
};
var MyTopHands = /*#__PURE__*/function (_React$Component) {
  _inherits(MyTopHands, _React$Component);
  var _super = _createSuper(MyTopHands);
  function MyTopHands(props) {
    var _this;
    _classCallCheck(this, MyTopHands);
    _this = _super.call(this, props);
    _this.getCurrencySymbol = function (currency) {
      console.log("getCurrencySymbol..........", currency);
      var currenciesList = [{
        key: 'USD',
        code: "$"
      }, {
        key: 'EUR',
        code: "\u20AC"
      }, {
        key: 'GBP',
        code: "\xA3"
      }, {
        key: 'CAD',
        code: "C".concat("$")
      }, {
        key: 'RUB',
        code: "\u20BD"
      }, {
        key: 'DKK',
        code: "K".concat("r").concat(".")
      }, {
        key: 'GEL',
        code: "\u20BE"
      }];
      var currencyObj = currenciesList.filter(function (obj) {
        return currency === obj.key;
      });
      if (currencyObj.length > 0) return currencyObj[0].code;else return "$";
    };
    _this.showOrHideHands = function (condition, handListType) {
      if (condition) {
        var data = {},
          activityTrack = [],
          track = {
            hit_timestamp: (0, _moment["default"])().format(),
            session_id: localStorage.getItem("token"),
            userid: localStorage.getItem("username"),
            deviceInfo: JSON.parse(localStorage.getItem("deviceInfo")),
            hit_page: "ReportCard",
            hit_type: handListType === "won" ? "ReportCardWinningShowMore" : "ReportCardLosingShowMore",
            hit_attribute1: "",
            hit_attribute2: "",
            hit_attribute3: "",
            hit_attribute4: "",
            hit_attribute5: ""
          };
        data["".concat(handListType, "ShowMore")] = true;
        if (localStorage.getItem("activityTrack")) activityTrack = JSON.parse(localStorage.getItem("activityTrack"));
        activityTrack.push(track);
        localStorage.setItem("activityTrack", JSON.stringify(activityTrack));
        if (_this.props.desktopView) {
          console.log("toggleCommonFlag");
          _this.props.toggleCommonFlag();
        } else {
          console.log("old flag toggle");
          _this.setState(data);
        }
      } else {
        var _data = {};
        _data["".concat(handListType, "ShowMore")] = false;
        if (_this.props.desktopView) {
          console.log("toggleCommonFlag");
          _this.props.toggleCommonFlag();
        } else {
          console.log("old flag toggle");
          _this.setState(_data);
          // setTimeout(() => {
          //     this.setState(data);
          // }, 250);
        }
      }
    };
    _this.numberWithCommas = function (x) {
      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    };
    _this.state = {
      wonShowMore: false,
      lostShowMore: false
    };
    return _this;
  }
  _createClass(MyTopHands, [{
    key: "generateCardLinks",
    value: function generateCardLinks(cards) {
      var imgUrls = [];
      var typeOfCards = ['club', 'diamond', 'heart', 'spade'];
      var _iterator = _createForOfIteratorHelper(cards),
        _step;
      try {
        var _loop = function _loop() {
          var card = _step.value;
          var cardName = typeOfCards.find(function (type) {
            return type.indexOf(card[card.length - 1]) > -1;
          });
          cardName = '/images/cards2x/' + cardName + '/' + card.trim() + '.png';
          imgUrls.push(cardName);
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return imgUrls;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var themeColor = (0, _ThemeService.getColor)();
      var blankCard = this.props.domain + "/images/Dark_Card.png";
      var cashout = this.props.domain + "/images/handReplay/cashout.png";
      var flopDefault = [blankCard, blankCard, blankCard];
      var condition = this.props.desktopView ? this.props.showMoreBothFlag === false : this.state["".concat(this.props.handListType, "ShowMore")] == false;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: " myTopPot".concat(this.props.handListType === 'lost' ? 'Loss' : 'Win', " ").concat(this.props.isMyStatistics ? " ms_myTopPotWinLose " : ""),
        style: {
          paddingBottom: this.props.hands && this.props.hands.length <= 5 ? "36px" : "0px",
          height: "auto"
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "myBiggestPotsCss"
      }, this.props.i18next.t("lable.myTop"), " ", condition ? "5" : "10", " ", this.props.isMyStatistics && this.props.gameType === "spin" && /*#__PURE__*/_react["default"].createElement("span", {
        className: "hideEVForDesktop"
      }, "EV Adjusted"), " ", this.props.handListType === "lost" ? "Loses" : "Wins"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "MyPotsColumnHeadings"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "MyPotsColumnHeadings_headerText holeCardsHeadingWidth"
      }, this.props.i18next.t("lable.cards")), /*#__PURE__*/_react["default"].createElement("span", {
        className: "MyPotsColumnHeadings_headerText flopCardsHeadingWidth",
        style: {
          marginLeft: "8px"
        }
      }, this.props.i18next.t("lable.Flop")), /*#__PURE__*/_react["default"].createElement("span", {
        className: "MyPotsColumnHeadings_headerText trunHeadingWidth"
      }, this.props.i18next.t("lable.Turn")), /*#__PURE__*/_react["default"].createElement("span", {
        className: "MyPotsColumnHeadings_headerText riverHeadingWidth"
      }, this.props.i18next.t("lable.River")), /*#__PURE__*/_react["default"].createElement("span", {
        className: "MyPotsColumnHeadings_headerText",
        style: {
          marginLeft: "10px"
        }
      }, this.props.i18next.t("lable.Profit"))), /*#__PURE__*/_react["default"].createElement("div", {
        "data-e2e": "potsLoss",
        className: "handsRowWrapper"
      }, this.props.hands && this.props.hands.length > 0 ? this.props.hands.map(function (item, index) {
        var flopCardUrl = [];
        var turnCardUrl = [];
        var rivercardUrl = [];
        if (item.communityCards && item.communityCards.length > 0 && item.communityCards[0].cards.length === 3) {
          flopCardUrl = _this2.generateCardLinks(item.communityCards[0].cards);
        }
        if (item.communityCards && item.communityCards.length > 1 && item.communityCards[1].cards.length > 0) {
          turnCardUrl = _this2.generateCardLinks(item.communityCards[1].cards);
        }
        if (item.communityCards && item.communityCards.length > 2 && item.communityCards[2].cards.length > 0) {
          rivercardUrl = _this2.generateCardLinks(item.communityCards[2].cards);
        }
        if (condition) {
          if (index > 4) return;
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: index,
          "data-e2e": "".concat(_this2.props.isMyStatistics ? "myStats-" : "", "singleTopHand"),
          className: "myHandDetailsRow"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "myhandCardImages holeCardsValueWidth"
        }, item.cardUrl.map(function (card, index) {
          return /*#__PURE__*/_react["default"].createElement("img", {
            key: index,
            className: "MyTopHandsCardsCss",
            "data-e2e": _this2.props.isMyStatistics ? "cardImgPotWin" : "cardImgPotLoss",
            src: card
          });
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "myhandFlopCardImages flopCardsValueWidth hideColumnMyTopHandForMobile"
        }, flopCardUrl.length > 0 ? flopCardUrl.map(function (card, index) {
          return /*#__PURE__*/_react["default"].createElement("img", {
            key: index,
            className: "MyTopHandsCardsCss",
            src: card
          });
        }) : flopDefault.map(function (card, index) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: index,
            className: "MyTopHandsCardsCss",
            style: {
              display: "inline-block",
              backgroundColor: "#F5F5F5",
              boxShadow: "1px 1px 4px 0px lightgrey"
            }
          });
        })), /*#__PURE__*/_react["default"].createElement(TurnOrRiverCard, {
          name: "myhandTrunCardImages hideColumnMyTopHandForMobile",
          blankCard: blankCard,
          innerWidth: "10%",
          cardUrl: turnCardUrl
        }), /*#__PURE__*/_react["default"].createElement(TurnOrRiverCard, {
          name: "myhandRiverCardImages hideColumnMyTopHandForMobile",
          blankCard: blankCard,
          innerWidth: "11%",
          cardUrl: rivercardUrl
        }), /*#__PURE__*/_react["default"].createElement("span", {
          className: "myliveReport_profitLoss profitValueWidth",
          style: {
            color: "".concat(_this2.props.handListType === 'lost' ? "#858585" : "#71C812"),
            fontFamily: "Roboto",
            fontSize: "14px",
            letterSpacing: "0.04px",
            marginTop: "10.5px",
            lineHeight: "17px"
          }
        }, _this2.props.gameType !== "tournament" ? item.profit < 0 ? "-" : "+" : "", _this2.props.gameType != "tournament" && _this2.props.gameType.toLowerCase() != "spin" && _this2.getCurrencySymbol(_this2.props.currency), _this2.numberWithCommas(Math.abs(item.profit.toFixed(2))), "\xA0", _this2.props.gameType === "tournament" && "BB", _this2.props.gameType.toLowerCase() === "spin" && "BB"), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("img", {
          style: {
            marginRight: "5px",
            height: "35px",
            width: "30px",
            visibility: item.cashoutHand ? 'visible' : 'hidden'
          },
          src: cashout,
          key: index
        })), localStorage.getItem("userRole").indexOf("PLAYER") != -1 && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("i", {
          className: "".concat(item.staredHand ? "fa fa-star" : "fa fa-star-o"),
          style: {
            fontSize: "25px",
            color: themeColor,
            marginTop: "6px",
            marginRight: "10px",
            cursor: "pointer"
          },
          onClick: function onClick(e) {
            e.preventDefault();
            _this2.props.setStarFlagOfHnad(item, !item.staredHand, _this2.props.handListType);
          }
        })), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("i", {
          className: "fa fa-play-circle replayButtonNewReportCard",
          "data-e2e": _this2.props.isMyStatistics ? "myStats-TopHandReplay-button" : "lossReplay",
          style: {
            fontSize: "35px",
            color: themeColor,
            marginTop: "1px",
            cursor: "pointer"
          },
          onClick: function onClick(e) {
            e.preventDefault();
            _this2.props.handReplayerOpen(item, _this2.props.handListType);
          }
        })));
      }) : /*#__PURE__*/_react["default"].createElement("h5", null, this.props.i18next.t("lable.noHandsFound"))), this.props.hands && this.props.hands.length > 5 && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "MyPotsshowMoreOrLessTopHands",
        onClick: function onClick() {
          _this2.showOrHideHands(condition, _this2.props.handListType);
        },
        style: {
          color: themeColor
        }
      }, condition ? /*#__PURE__*/_react["default"].createElement("i", {
        "data-e2e": "".concat(this.props.isMyStatistics ? "myStats-" : "", "topHands-seeMoreButton"),
        className: "fa fa-chevron-down"
      }) : /*#__PURE__*/_react["default"].createElement("span", {
        "data-e2e": "".concat(this.props.isMyStatistics ? "myStats-" : "", "topHands-seeLessButton")
      }, /*#__PURE__*/_react["default"].createElement("i", {
        "data-e2e": "seeless",
        className: "fa fa-chevron-up"
      })))));
    }
  }]);
  return MyTopHands;
}(_react["default"].Component);
var _default = MyTopHands;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/MyTopHands.js
 ** module id = 2387
 ** module chunks = 0
 **/